import React from "react";
import { Button, Popconfirm, Space, Tooltip } from "antd";
import { QuestionCircleOutlined } from "@ant-design/icons";
import { Icon } from "@iconify/react";
import { Landlord } from "js/components/types";
import { useDeleteLandlord } from "hooks/useLandlords";
import { ActionSelect } from "js/components/Landlords/types";

const LandlordActionSelect: React.FC<ActionSelect> = ({
  landlord,
  data,
  setData,
  setIsLandlordModalOpen,
  setSelectedLandlord,
  messageApi,
}) => {
  const deleteLandlordMutation = useDeleteLandlord();

  const handleDeleteLandlord = (landlordId: string) => {
    deleteLandlordMutation.mutate(landlordId, {
      onSuccess: () => {
        messageApi.success("Propietario eliminado correctamente");
      },
      onError: () => {
        messageApi.error(
          "No se pudo eliminar el propietario, inténtalo de nuevo.",
        );
      },
    });
  };

  return (
    <Space wrap>
      <Tooltip title="Actualizar datos de Propietario" placement="top">
        <Button
          size={"small"}
          type={"link"}
          onClick={() => {
            setSelectedLandlord(landlord);
            setIsLandlordModalOpen(true);
          }}
        >
          <Icon fontSize={20} icon="akar-icons:edit" />
        </Button>
      </Tooltip>
      <Tooltip title="Eliminar Propietario" placement="bottom">
        <Popconfirm
          title="Eliminar"
          description="¿Seguro que deseas eliminar?"
          onConfirm={() => handleDeleteLandlord(landlord.id)}
          icon={
            <QuestionCircleOutlined style={{ color: "red" }} rev={undefined} />
          }
          okText={"Ok"}
          cancelText={"Cancelar"}
        >
          <Button
            danger
            size={"small"}
            type={"link"}
            loading={deleteLandlordMutation.isPending}
          >
            <Icon fontSize={20} icon="bi:trash3" />
          </Button>
        </Popconfirm>
      </Tooltip>
    </Space>
  );
};
export default LandlordActionSelect;
